import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ErrorPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const errorMessage = searchParams.get('message') || 'An unexpected error occurred';

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '2rem'
    }}>
      <div style={{
        maxWidth: '600px',
        width: '100%',
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        padding: '3rem',
        textAlign: 'center'
      }}>
        {/* Error Icon */}
        <div style={{
          width: '80px',
          height: '80px',
          margin: '0 auto 2rem',
          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '3rem'
        }}>
          ⚠️
        </div>

        {/* Error Title */}
        <h1 style={{
          margin: '0 0 1rem 0',
          fontSize: '2rem',
          color: '#2c3e50',
          fontWeight: '700'
        }}>
          Oops! Something Went Wrong
        </h1>

        {/* Error Message */}
        <p style={{
          margin: '0 0 2rem 0',
          fontSize: '1.1rem',
          color: '#666',
          lineHeight: '1.6'
        }}>
          We encountered a server error while processing your request. We've tried multiple times, but the issue persists.
        </p>

        {/* Technical Details (collapsible) */}
        <details style={{
          marginBottom: '2rem',
          padding: '1rem',
          background: '#f8f9fa',
          borderRadius: '8px',
          textAlign: 'left'
        }}>
          <summary style={{
            cursor: 'pointer',
            fontWeight: '600',
            color: '#4A90E2',
            userSelect: 'none'
          }}>
            Technical Details
          </summary>
          <p style={{
            margin: '1rem 0 0 0',
            fontSize: '0.9rem',
            color: '#666',
            wordBreak: 'break-word'
          }}>
            {errorMessage}
          </p>
        </details>

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={() => navigate('/dashboard')}
            style={{
              padding: '0.875rem 2rem',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
            }}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.6)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
            }}
          >
            Go to Dashboard
          </button>

          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '0.875rem 2rem',
              background: 'white',
              color: '#667eea',
              border: '2px solid #667eea',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#667eea';
              e.target.style.color = 'white';
            }}
            onMouseOut={(e) => {
              e.target.style.background = 'white';
              e.target.style.color = '#667eea';
            }}
          >
            Try Again
          </button>
        </div>

        {/* Help Text */}
        <p style={{
          margin: '2rem 0 0 0',
          fontSize: '0.9rem',
          color: '#999'
        }}>
          If this problem persists, please contact our support team.
        </p>
      </div>
    </div>
  );
};

export default ErrorPage;
